import { Button } from "@/components/ui/button";
import { Card, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { ReactComponent as RedExclamation } from "@/assets/icons/Exclamation-Red.svg";
import CancelSubscription from "./cancel-subscription";
import usePaddle from "@/contexts/paddle/paddle-context";
import useMusioApi from "@/contexts/client/musio-client-context";

// TODO: add error handling
export const PastDueCard = () => {
  const paddle = usePaddle();
  const { musioApi } = useMusioApi();

  const { mutate } = musioApi.useMutation("post", "/user/billing", {
    onSuccess: (data) => { paddle?.Checkout.open({ transactionId: data.txnId! }) }
  });

  return (
    <Card className="relative musio-glass max-w-[373px] w-full flex flex-col space-y-6 justify-between p-0" style={{ backgroundColor: "var(--musio-bg)" }}>
      <RedExclamation className="absolute top-8 right-2 h-3 w-3" />
      <CardHeader className="pb-2">
        <CardTitle className="flex flex-col space-y-0.5 items-center align-middle justify-center">
          <p className="text-xl font-semibold text-center text-musio-red">Past Due</p>
          <p className="text-center font-normal text-sm text-lilac">Payment was due May 4th, 2025</p>
        </CardTitle>
      </CardHeader>

      <CardFooter className="flex flex-col gap-0.5 card-footer-padded">
        <div className="flex flex-col space-y-1">
          <Button
            className="w-full py-2 bg-musio-orange text-musio-light-lilac"
            onClick={() => mutate({})}
          >
            Update Payment Method
          </Button>
        </div>
        <CancelSubscription />
      </CardFooter>
    </Card>
  );
};
